// This is an expensive component to use, as it loads the SVGs eagerly.
// ONLY use this component for icons that need to change when clicked. (like the navigation icons)
import React from 'react';
import MapIcon from '../assets/SVGs/Map'
import OrganisationIcon from '../assets/SVGs/Organisations';
import UserIcon from '../assets/SVGs/User';
import ProductIcon from '../assets/SVGs/Product';
import FeedIcon from '../assets/SVGs/Feed';
import SettingsIcon from '../assets/SVGs/Settings';
import MarketplaceIcon from '../assets/SVGs/Marketplace';
import SubscriptionIcon from '../assets/SVGs/Subscription';
import NtripIcon from '../assets/SVGs/Ntrip';
import StarSolidIcon from '../assets/SVGs/StarSolid';
import StarOutlineIcon from '../assets/SVGs/StarOutline';
import SuccessIcon from '../assets/SVGs/Success';
import CopyIcon from '../assets/SVGs/CopyIcon';
import ProfileIcon from '../assets/SVGs/Profile';
import ArrowLeftIcon from '../assets/SVGs/ArrowLeft';
import HamburgerMenuIcon from '../assets/SVGs/HamburgerMenu';
import FilterIcon from '../assets/SVGs/Filter';
import LightAndDarkModeIcon from '../assets/SVGs/LightAndDarkMode';
import CloseIcon from '../assets/SVGs/Close';
import RtkSignalIcon from '../assets/SVGs/RtkSignal';
import ConnectionOffIcon from '../assets/SVGs/ConnectionOff';
import ConnectionOnIcon from '../assets/SVGs/ConnectionOn';
import OutgoingLinkIcon from '../assets/SVGs/OutgoingLink';
import OutgoingLinkRoundedIcon from '../assets/SVGs/OutgoingLinkRounded';
import ConnectionsIcon from '../assets/SVGs/Connections';
import ExpiryIcon from '../assets/SVGs/Expiry';
import DeleteIcon from '../assets/SVGs/Delete';
import SearchIcon from '../assets/SVGs/Search';
import GridIcon from '../assets/SVGs/Grid';
import TableIcon from '../assets/SVGs/Table';
import SourceAccountIcon from '../assets/icon-components/SourceAccountIcon';
import StackIcon from '../assets/SVGs/Stack';
import CreateConnectionsIcon from '../assets/SVGs/CreateConnections';
import LoginIcon from '../assets/SVGs/Login';
import HelpIcon from '../assets/SVGs/Help';
import SendIcon from '../assets/SVGs/Send';
import DocumentIcon from '../assets/SVGs/Document';
import ICircleIcon from '../assets/SVGs/ICircle';
import CreditsIcon from '../assets/SVGs/Credits';
import ChevronRight from '../assets/SVGs/ChevronRight';
import RadarIcon from '../assets/SVGs/Radar';
import ApprovedIcon from '../assets/SVGs/Approved';

export type EagerSVGIconMap = 'ApprovedIcon' | 'ArrowLeftIcon' | 'CopyIcon' | 'FeedIcon' | 'MapIcon' | 'MarketplaceIcon' | 'OrganisationIcon' | 'NtripIcon' | 'UserIcon' | 'ProductIcon' | 'SettingsIcon' | 'StarOutlineIcon' | 'StarSolidIcon' | 'SubscriptionIcon' | 'SuccessIcon' | 'ProfileIcon' | 'HamburgerMenuIcon' | 'FilterIcon' | 'LightAndDarkModeIcon' | 'CloseIcon' | 'RtkSignalIcon' | 'ConnectionOffIcon' | 'ConnectionOnIcon' | 'OutgoingLinkIcon' | 'OutgoingLinkRoundedIcon' | 'ConnectionsIcon' | 'ExpiryIcon' | 'DeleteIcon' | 'SearchIcon' | 'GridIcon' | 'TableIcon' | 'SourceAccountIcon' | 'StackIcon' | 'CreateConnectionsIcon' | 'LoginIcon' | 'HelpIcon' | 'SendIcon' | 'DocumentIcon' | 'ICircleIcon' | 'CreditsIcon' | 'ChevronRight' | 'RadarIcon';

type EagerSVGIconProps = {
  name: EagerSVGIconMap
  className?: string;
  color?: string;
  width?: number;
  height?: number;
};

const iconMap: Record<string, React.ComponentType<any>> = {
  ApprovedIcon: ApprovedIcon,
  ArrowLeftIcon: ArrowLeftIcon,
  ChevronRight: ChevronRight,
  CloseIcon: CloseIcon,
  ConnectionOffIcon: ConnectionOffIcon,
  ConnectionOnIcon: ConnectionOnIcon,
  ConnectionsIcon: ConnectionsIcon,
  CopyIcon: CopyIcon,
  CreateConnectionsIcon: CreateConnectionsIcon,
  CreditsIcon: CreditsIcon,
  DeleteIcon: DeleteIcon,
  DocumentIcon: DocumentIcon,
  ExpiryIcon: ExpiryIcon,
  FeedIcon: FeedIcon,
  FilterIcon: FilterIcon,
  GridIcon: GridIcon,
  HelpIcon: HelpIcon,
  HamburgerMenuIcon: HamburgerMenuIcon,
  ICircleIcon: ICircleIcon,
  LightAndDarkModeIcon: LightAndDarkModeIcon,
  LoginIcon: LoginIcon,
  MapIcon: MapIcon,
  MarketplaceIcon: MarketplaceIcon,
  OrganisationIcon: OrganisationIcon,
  OutgoingLinkIcon: OutgoingLinkIcon,
  OutgoingLinkRoundedIcon: OutgoingLinkRoundedIcon,
  NtripIcon: NtripIcon,
  ProductIcon: ProductIcon,
  ProfileIcon: ProfileIcon,
  RadarIcon: RadarIcon,
  RtkSignalIcon: RtkSignalIcon,
  SearchIcon: SearchIcon,
  SendIcon: SendIcon,
  SettingsIcon: SettingsIcon,
  SourceAccountIcon: SourceAccountIcon,
  StackIcon: StackIcon,
  StarSolidIcon: StarSolidIcon,
  StarOutlineIcon: StarOutlineIcon,
  SubscriptionIcon: SubscriptionIcon,
  SuccessIcon: SuccessIcon,
  TableIcon: TableIcon,
  UserIcon: UserIcon
};

const EagerSVGIcon: React.FC<EagerSVGIconProps> = ({ name, ...props }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`EagerSVGIcon: Unknown icon name "${name}"`);
    return null;
  }

  return <IconComponent {...props} />;
};

export default EagerSVGIcon;
